module.exports = __webpack_public_path__ + "img/identityChecked2.47b084ec.png";